import React from "react"

export default {
	infos: React.createContext(null),
	display: React.createContext(null),
}